import React from 'react'

import d12 from './QuestionItem.module.css'
import {BsMicFill} from 'react-icons/bs'
import { updateDoc ,doc} from 'firebase/firestore'
import { db } from '../../firebase'

import imgAlt from '../media/questa img alt.png'
function QuestionItem(props) {
 
   
  async  function markAsRead(qid ,status ,read){
    
        if(status==='done'  && !read){    await updateDoc(doc(db, "questions", qid),{read:true,});console.log('question status changed')}
    }

    
    return (
        
        <  >
           
        <div 
        id={props.checked?d12.checked:null}
        className={d12.itemContainer} 
        onClick={()=>{ props.openFullView();markAsRead(props.questionData.question_id,props.questionData.question_status ,props.questionData.read)}}>
             <img height='80px' width='80px' src={( props.questionData.question_images[0]?.placeholder) || imgAlt} alt="no img" className={d12.question_img}></img>
            
                 <div className={d12.question}>
                            {!props.questionData.read && props.questionData.question_status==='done' && <div className={d12.unread}></div>} 
                            {props.questionData.question_audio && <BsMicFill/>}
                          {props.questionData.question.substring(0, 100)}</div>
                
                 <div className={d12.date}>{props.questionData.createdAt.toDate().toString().substring(0,21)}</div>
        
        </div>       
        </>
        
        
    )
}

export default QuestionItem

